/**
 * Click-to-load embed for the Microsoft Forms Mitgliedsantrag
 * (template-parts/mitglied-werden/forms-cta.php). The iframe src is
 * only set after an explicit click — no third-party request happens
 * on page load, matching docs/CLAUDE.md §12 ("Consent vor externen
 * Einbettungen"). Progressive enhancement: without JS, the fallback
 * link to open the form in a new tab stays fully usable.
 */
export function initFormsEmbed() {
  const wrapper = document.querySelector('[data-forms-embed]');

  if (!wrapper) {
    return;
  }

  const button = wrapper.querySelector('[data-forms-embed-load]');
  const url = wrapper.getAttribute('data-forms-embed-url');

  if (!button || !url) {
    return;
  }

  button.addEventListener('click', () => {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.title = button.getAttribute('data-forms-embed-title') || 'Mitgliedsantrag';
    iframe.loading = 'lazy';
    iframe.className = 'rsv-forms-cta__iframe';

    wrapper.querySelector('[data-forms-embed-placeholder]').replaceWith(iframe);
  });
}
